import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c63ac40c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = { class: "favorite" }
const _hoisted_3 = { class: "favorite__list" }
const _hoisted_4 = { class: "favorite__nav" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("decola shop ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "lista de favoritos", -1))
const _hoisted_8 = { class: "favorite__header" }
const _hoisted_9 = { class: "favorite__name-link" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "lista de favoritos", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Ir para o carrinho ")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "favorite__products" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "favorite__image" }
const _hoisted_17 = { class: "favorite__information" }
const _hoisted_18 = { class: "favorite__titles" }
const _hoisted_19 = { class: "favorite__description" }
const _hoisted_20 = { class: "favorite__description" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "favorite__title--upper" }, "Data de adição:", -1))
const _hoisted_22 = { class: "favorite__decoins" }
const _hoisted_23 = {
  key: 0,
  class: "favorite__validation-decoins"
}
const _hoisted_24 = {
  key: 1,
  class: "favorite__validation-decoins"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "favorite__validation" }, null, -1))
const _hoisted_26 = { class: "favorite__buttons" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_31 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HoverGallery = _resolveComponent("HoverGallery")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_PaginationDefault = _resolveComponent("PaginationDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: { name: 'shop' },
              class: "favorite__link"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6,
            _hoisted_7
          ]),
          _createElementVNode("header", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_router_link, {
                to: { name: 'bag' },
                class: "favorite__link-bag"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            (_ctx.favoriteProducts.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Veja abaixo os produtos adicionados em sua Lista de Favoritos. "))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, "Você não possui produtos na Lista de Favoritos."))
          ]),
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favoriteProducts, (product, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "favorite__detail"
              }, [
                _createElementVNode("div", {
                  class: "favorite__container",
                  onClick: ($event: any) => (_ctx.goToProductDetail(product))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_HoverGallery, {
                      gallery: product.imagesUrl
                    }, null, 8, ["gallery"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("h2", null, _toDisplayString(product.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_TUIViewer, {
                          "model-value": product.description
                        }, null, 8, ["model-value"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("p", null, _toDisplayString(_ctx.formattedDate(product.lastChange)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatDecoins(product.decoins)), 1)
                    ]),
                    (
                      _ctx.checkProductDecoins(product) &&
                        _ctx.bagIncludes(product) &&
                        !_ctx.checkProductIsActive(product)
                    )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Valor do produto modificado, você não possui decoins suficientes para adquirir este produto. "))
                      : _createCommentVNode("", true),
                    (_ctx.checkProductIsActive(product))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Produto indisponível. "))
                      : _createCommentVNode("", true),
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      (!_ctx.bagIncludes(product))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: [
                              _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                              ($event: any) => (_ctx.addToBag(product))
                            ],
                            class: _normalizeClass([
                        _ctx.hasEnoughDecoins(product) ||
                        _ctx.isProductOutOfStock(product) ||
                        !_ctx.checkEnough(product) ||
                        _ctx.checkProductIsActive(product)
                          ? 'favorite__button-blocked'
                          : 'favorite__button-add'
                      ])
                          }, _toDisplayString(_ctx.setButtonText(product)), 11, _hoisted_27))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: [
                              _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                              ($event: any) => (_ctx.removeFromBag(product))
                            ],
                            class: "favorite__button-remove"
                          }, " remover do carrinho ", 8, _hoisted_28)),
                      _createElementVNode("button", {
                        onClick: [
                          _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                          ($event: any) => (_ctx.removeFromFavoriteList(product.id))
                        ],
                        class: "favorite__button-active"
                      }, " remover ", 8, _hoisted_29)
                    ])
                  ])
                ], 8, _hoisted_15),
                _hoisted_30
              ]))
            }), 128))
          ])
        ])
      ]),
      (_ctx.pages !== 0)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_31, [
            _createVNode(_component_PaginationDefault, {
              "qt-pages": _ctx.pages,
              currentPage: _ctx.currentPage,
              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event))
            }, null, 8, ["qt-pages", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}